import { z } from "zod";
import { addressStatusSchema } from "./address-status.js";
export const invitationStatuses = ["unsent", "sent", "pending"];
export var SendVia;
(function (SendVia) {
    SendVia["EMAIL"] = "email";
    SendVia["SMS"] = "sms";
})(SendVia || (SendVia = {}));
export var SendToAllVariant;
(function (SendToAllVariant) {
    SendToAllVariant["Unsent"] = "unsent";
    SendToAllVariant["Sent"] = "sent";
    SendToAllVariant["SentNotSubmitted"] = "sent-not-submitted";
})(SendToAllVariant || (SendToAllVariant = {}));
export var ContributorUnsubscribeFrom;
(function (ContributorUnsubscribeFrom) {
    ContributorUnsubscribeFrom["ORGANIZER"] = "organizer";
    ContributorUnsubscribeFrom["ALL"] = "all";
})(ContributorUnsubscribeFrom || (ContributorUnsubscribeFrom = {}));
const sendStatuses = ["pending", "sent"];
function getIsSendStatus(sendStatus) {
    return sendStatuses.includes(sendStatus);
}
export function guardSendStatus(sendStatus, fallback = "sent") {
    return getIsSendStatus(sendStatus) ? sendStatus : fallback;
}
export const contributorSimpleSchema = z.object({
    cardId: z.string(),
    cardUrl: z.string(),
    contributorId: z.string(),
    email: z.string().optional(), // indexed, cannot be null
    sms: z.string().optional(), // indexed, cannot be null
    sendVia: z.enum(SendVia),
    contributorName: z.string(), // cognito username
});
export const contributorSchema = contributorSimpleSchema.extend({
    organizerUsername: z.string(), // username of organizer of the GV
    organizerDisplayName: z.string().optional(), // name of organizer of the GV
    addedByOrganizer: z.boolean(), // added by invitation (true) or by general video submission (false)
    // Contact has opted out of receiving comms for this GV. The only reason this
    // is optional is that some contributors in the database have this prop undefined.
    declined: z.boolean().optional(),
    removed: z.boolean(), // Organizer uninvited them
    lastInviteSentAt: z.number().int().nonnegative().nullable(), // If non-null, invite was sent
    lastVisitedPageAt: z.number().int().nonnegative().nullable(), // If non-null, they viewed the page
    lastSegmentUploadedAt: z.number().int().nonnegative().nullable(), // If non-null, they submitted a segment
    // The only reason this is optional is that some contributors in the database
    // have this prop undefined.
    undeliverableNotifiedAt: z.number().int().nonnegative().nullable().optional(),
    undeliverableAt: z.number().int().nonnegative().nullable(),
    createdAt: z.number().int().nonnegative(),
    smsMessageId: z.string().optional(),
    addressStatus: z.record(z.string(), addressStatusSchema).optional(),
    username: z.string().optional(), // The cognito username of this contributor, if they have an account
    lastSmsReply: z.string().optional(), // The last SMS reply from this contributor
    // Optional only because old values in the database might not have it set.
    // Use getInvitationStatus() to derive the status.
    invitationStatus: z.enum(invitationStatuses).optional(),
});
/**
 * Derive the invitation status for a contributor.
 * For existing contributors without the invitationStatus field, this function
 * derives the status from the lastInviteSentAt field.
 */
export function getInvitationStatus(contributor) {
    if (contributor.invitationStatus) {
        return contributor.invitationStatus;
    }
    else {
        // Derive for existing contributors without the field
        return contributor.lastInviteSentAt ? "sent" : "unsent";
    }
}
